import { VisitRequestPermissions, VisitRequestWorkflowStep } from '@/types/graphql';
import { Objects } from '@/types/objects';

type VisitRequestReassignPermission = {
    workflowStep: VisitRequestWorkflowStep;
    permissions: Objects.SubType<VisitRequestPermissions, 'edit'>;
};
type UseCanReassignVisitRequest = <T extends VisitRequestReassignPermission>(
    visit?: T | null,
) => boolean;

export const useCanReassignVisitRequest: UseCanReassignVisitRequest = (visitRequest) => {
    const isValidWorkflowStep =
        !!visitRequest &&
        visitRequest.workflowStep !== VisitRequestWorkflowStep.NEEDS_SERVICES &&
        visitRequest.workflowStep !== VisitRequestWorkflowStep.NEEDS_CLINICIAN;

    return !!visitRequest && isValidWorkflowStep && visitRequest.permissions.edit;
};

// Helper to check if a visit request has services for reassignment
type VisitRequestWithServices = {
    appointments: {
        services: { id: string }[];
    }[];
};
export const visitRequestHasServices = <T extends VisitRequestWithServices>(
    visitRequest?: T | null,
): boolean => {
    if (!visitRequest) {
        return false;
    }
    return visitRequest.appointments.some((appointment) => appointment.services.length > 0);
};

export const REASSIGN_DISABLED_NO_SERVICES_TOOLTIP =
    'Visit must have a service to be reassigned' as const;
